import { noop } from 'lodash';
import { memo } from 'react';
import { useStyles } from './styles';
import ManualRedactionForm from './ManualRedactionForm';
import Popover, { PopoverPosition } from '@mui/material/Popover';
import {
  AudioEditSlice,
  AudioEditType,
  BlurLevel,
} from '@common-modules/mediaDetails/models';
import { useSelector } from 'react-redux';
import { selectAudioPreview } from '@common/state/modules/mediaDetails';
import { BackgroundBlurSlice } from '@common/state/modules/mediaDetails/store.models';
import { BACKGROUND_BLUR_ACTION_TYPE } from '../BackgroundBlur';

const TimelineRangeEditorPopup = ({
  minMs,
  maxMs,
  anchorPosition,
  isOpen,
  timeRange,
  hideGroupButton,
  onChange = noop,
  onCancel,
  onSetRangeTime,
  handleResetSlice,
  isBlurForm,
}: TimelineRangeEditorPopupPropTypes) => {
  const classes = useStyles();
  const audioPreview = useSelector(selectAudioPreview);
  return (
    <Popover
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      open={audioPreview === 'voice_mask' ? false : isOpen}
      style={{ zIndex: 101 }}
      disableRestoreFocus
      onClose={onCancel}
    >
      <div className={classes.manualRedactPopperContent}>
        <ManualRedactionForm
          {...{
            minMs,
            maxMs,
            timeRange,
            onCancel,
            onSetRangeTime,
            onChange,
            hideGroupButton,
            handleResetSlice,
            isBlurForm,
          }}
        />
      </div>
    </Popover>
  );
};

export default memo(TimelineRangeEditorPopup);

export interface TimelineRangeEditorPopupPropTypes {
  readonly minMs: number;
  readonly maxMs: number;
  readonly anchorPosition: PopoverPosition;
  readonly isOpen: boolean;
  readonly timeRange: AudioEditSlice | BackgroundBlurSlice;
  readonly hideGroupButton: boolean;
  readonly onCancel: () => void;
  readonly onChange?: (tr: [start: number, stop: number]) => void;
  readonly onSetRangeTime: (
    start: number,
    stop: number,
    options: {
      type?: AudioEditType;
      blurLevel?: BlurLevel;
    }
  ) => void;
  readonly handleResetSlice: (start: number, stop: number) => void;
  readonly isBlurForm?: boolean;
  readonly editMode?: BACKGROUND_BLUR_ACTION_TYPE;
}
